var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrangeI(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0016 0.998047C15.5253 0.998047 20.0031 5.47589 20.0031 10.9996C20.0031 16.5233 15.5253 21.0011 10.0016 21.0011C4.47785 21.0011 0 16.5233 0 10.9996C0 5.47589 4.47785 0.998047 10.0016 0.998047ZM9.99774 9.24863C9.48491 9.24897 9.06249 9.63528 9.00505 10.1327L8.9984 10.2493L9.002 15.7509L9.0088 15.8675C9.06689 16.3648 9.48982 16.7506 10.0027 16.7502C10.5155 16.7499 10.9379 16.3636 10.9953 15.8662L11.002 15.7496L10.9984 10.248L10.9916 10.1314C10.9335 9.63406 10.5106 9.24829 9.99774 9.24863ZM10.002 5.49908C9.3108 5.49908 8.75048 6.0594 8.75048 6.7506C8.75048 7.4418 9.3108 8.00212 10.002 8.00212C10.6932 8.00212 11.2535 7.4418 11.2535 6.7506C11.2535 6.0594 10.6932 5.49908 10.002 5.49908Z",
    fill: "#DD6F0C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeI);
export default __webpack_public_path__ + "static/media/orange-i.c27d65cea0e44d9902983ad84ba50413.svg";
export { ForwardRef as ReactComponent };